import { render, staticRenderFns } from "./FieldExerciseCategory.vue?vue&type=template&id=465b144a"
import script from "./FieldExerciseCategory.vue?vue&type=script&lang=js"
export * from "./FieldExerciseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465b144a')) {
      api.createRecord('465b144a', component.options)
    } else {
      api.reload('465b144a', component.options)
    }
    module.hot.accept("./FieldExerciseCategory.vue?vue&type=template&id=465b144a", function () {
      api.rerender('465b144a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fields/FieldExerciseCategory.vue"
export default component.exports